<script setup lang="ts">
import { ActionTypes, MutationTypes } from '@/store/store_types'
import { computed, getCurrentInstance, nextTick, onMounted } from 'vue'
import { useStore } from 'vuex'
import AccountNeededAlert from './components/alert-popup/AccountNeededAlert.vue'
import DashboardDialog from './components/dashboard/DashboardDialog.vue'
import MainDialog from './components/dialog-wrappers/MainDialog.vue'
import SecondaryDialog from './components/dialog-wrappers/SecondaryDialog.vue'
import TertiaryDialog from './components/dialog-wrappers/TertiaryDialog.vue'
import InfoPanelControls from './components/Info-panel/InfoPanelControls.vue'
import BottomLogo from './components/map-panel/BottomLogo.vue'
import LeafletMap from './components/map-panel/LeafletMap.vue'
import NetworkFilter from './components/settings/NetworkFilter.vue'
import TutorialWizardMain from './components/tutorial-wizard/TutorialWizardMain.vue'

const store = useStore()
const instance = getCurrentInstance()
const $Countly = instance?.appContext.config.globalProperties.$Countly

const showDashboard = computed(() => store.state.showDashboard)

function startRefresh() {
  setTimeout(() => {
    store.dispatch(ActionTypes.refreshData)
    startRefresh()
  }, 300000)
}

function toggleDashboard(show: boolean) {
  store.commit(MutationTypes.setShowDashboard, show)
}

onMounted(() => {
  $Countly.q.push(['track_pageview', 'landing'])
  nextTick(async() => {
    store.dispatch(ActionTypes.fetchData)
    startRefresh()
  })
})

</script>

<template>
  <v-app>
    <v-main>
      <LeafletMap />
      <NetworkFilter />
      <MainDialog />
      <SecondaryDialog />
      <TertiaryDialog />
      <InfoPanelControls @showDashboard="toggleDashboard(true)" />
      <BottomLogo />
      <DashboardDialog :activator="showDashboard" @close="toggleDashboard(false)" />
      <AccountNeededAlert />
      <TutorialWizardMain />
    </v-main>
  </v-app>
</template>

<style lang="scss">
@import 'https://cdn.jsdelivr.net/npm/vuetify/dist/vuetify.min.css';
@import url('https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css');
@import url('https://fonts.googleapis.com/css2?family=Public+Sans:ital,wght@0,100..900;1,100..900&display=swap');

.v-application {
  font-family: 'Public Sans', Roboto, sans-serif !important;
  background-color: rgb(var(--v-theme-background)) !important;
  color: rgb(var(--v-theme-pwt_black));
  letter-spacing: -0.1px;
}

.v-card,
.v-sheet,
.v-toolbar,
.v-tabs-items,
.v-expansion-panel,
.v-skeleton-loader__article,
.v-skeleton-loader__list-item-avatar,
.container {
  background-color: rgb(var(--v-theme-background));
}

.v-card__title {
  word-break: normal !important;
  letter-spacing: -0.4px;
}

.pwt-number-font {
  font-family: 'Inter', sans-serif !important;
}

#pwt-main-container {
  position: relative;
  width: 100vw;
  height: 100vh;
  height: 100svh;
}

.pwt-scroll-container {
  width: 100%;
  height: 100%;
}

.pwt-scrollbar-styles {
  scrollbar-color: #ffffff #e0e0e0;
  scrollbar-width: thin;
}

.pwt-scrollbar-styles:hover {
  scrollbar-color: #eeeeee #e0e0e0;
}

.pwt-scrollbar-styles::-webkit-scrollbar {
  width: 6px;
}

.pwt-scrollbar-styles::-webkit-scrollbar-track {
  background: #ffffff;
}

.pwt-scrollbar-styles::-webkit-scrollbar-track:hover {
  background: #e0e0e0;
}

.pwt-scrollbar-styles::-webkit-scrollbar-thumb {
  background: #ffffff;
}

.pwt-scrollbar-styles::-webkit-scrollbar-thumb:hover {
  background: #eeeeee;
}

.v-application--wrap {
  overflow: hidden;
  min-height: unset;
}
</style>
